// W4 — Marketplace → booking: the "Book" action on a practitioner card.
//
// `card.bookingSoon` used to sit here too, for a practitioner who had not finished their
// Stripe Connect onboarding. That state is not the visitor's business — Solunary is the
// merchant of record, so the practice is bookable and payable either way — and the card
// now always offers "Book".
export default {
  fr: {
    "card.book": "Réserver",
  },
  en: {
    "card.book": "Book",
  },
  es: {
    "card.book": "Reservar",
  },
};
